import * as htmlToImage from "html-to-image";
import { saveAs } from 'file-saver';

export async function getProfilePicture(name) {
  const node = document.querySelector('canvas');
  const currentDate = new Date();
  const date = currentDate.toLocaleDateString();
  const time = currentDate.toLocaleTimeString();

  // htmlToImage.toBlob(node, { skipAutoScale: true })
  //   .then(async function (blobFile) {
  //     if (window.saveAs) { 
  //       window.saveAs(blobFile, `CosmicChamps-${name}.png`);

  //     } else {
  //       FileSaver.saveAs(blobFile, `CosmicChamps-${name}.png`);
  //     }
  //   });

  htmlToImage.toJpeg(node).then(dataUrl => {
    htmlToImage.toJpeg(node).then(data => {
      var link = document.createElement('a');
      link.download = `CosmicChamps-${name}-${date}_${time}.jpeg`;
      link.href = data;
      link.click();
    })
  })
}